const clients = [
    { name: 'Next creation', logo: 'https://nextcreationsoftware.com/assets/logotaglinedark-CkQcNJee.png' },
    { name: 'Nextgen Tech', logo: 'https://nextgentechinc.com/wp-content/uploads/2023/08/Nextgen-Technologies-300x29.png.webp' },
    { name: 'Aatman corp', logo: 'https://aatmancorp.in/wp-content/uploads/2022/10/cropped-Aatman-Corporation-Curve.png' },
    { name: 'Ariana Solution', logo: 'https://arianasolution.com/logo.png' },
];

export default clients;
